import { isJsonSerializable } from 'utils/isJsonSerializable'

export async function runWebWorker<WorkerReturnType>(
  worker: Worker,
  props: unknown,
  transfer: Transferable[] = []
): Promise<WorkerReturnType> {
  if (transfer.length === 0 && !isJsonSerializable(props)) {
    throw new Error('worker props must be JSON serializable')
  }
  return new Promise((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<WorkerReturnType>) => {
      resolve(event.data)
      worker.terminate()
    }
    worker.onerror = (event) => {
      reject(getWebWorkerError(event))
      worker.terminate()
    }
    worker.onmessageerror = (event) => {
      reject(getWebWorkerError(event))
      worker.terminate()
    }
    if (transfer.length > 0) {
      worker.postMessage(props, transfer)
    } else {
      worker.postMessage(props)
    }
  })
}

function getWebWorkerError(event: ErrorEvent | MessageEvent): Error {
  if ('error' in event && event.error instanceof Error) {
    return event.error
  }

  if ('message' in event && event.message) {
    return new Error(event.message)
  }

  return new Error('Web worker failed without an error message.')
}
